// extracted by mini-css-extract-plugin
module.exports = {"inputContainerStyles":"MultiSelectQuestion_inputContainerStyles__33KR7","checkboxStyles":"MultiSelectQuestion_checkboxStyles__1Bdfg"};